import downloadDocumentBuilder from '@/usecases/documents/uploaded/downloadDocument';
import uploadedRepository from '@/repositories/documents/uploaded';
import downloadFile from '@/services/documents/downloadFile';

export default {
  downloadDocument: downloadDocumentBuilder({ uploadedRepository, downloadFile }),
};
